export default
{
    listCargas: "/lavanderia/listCargas",
    listCatalogoLavanderia: "/lavanderia/listCatalogoLavanderia",
    guardaCarga: "/lavanderia/guardaCarga",

    listCatalogoAreas: "/lavanderia/listCatalogoAreas",
}